<app-navbar-style-two></app-navbar-style-two>

<div class="privacy-policy-section">
  <div class="container">
    <div class="policy-header">
      <h1>Damage Policy</h1>
      <p>
        We follow strict quality control and packaging standards. However, in the rare case of breakage, our damage policy is as follows:
      </p>
    </div>

    <div class="policy-content">
      <div class="policy-item">
        <h4>1. Damage Allowance</h4>
        <ul>
          <li>Industry-standard allows for 3–5% breakage during transport, which is not considered claimable.</li>
          <li>Breakage exceeding 5% must be reported with photographic evidence within 24 hours.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>2. Claims</h4>
        <ul>
          <li>Valid damage claims will be compensated via replacement tiles (if in stock) or credit notes.</li>
        </ul>
      </div>

      <div class="policy-item">
        <h4>3. Exclusions</h4>
        <ul>
          <li>Damage due to mishandling at the customer’s site or after unloading is not eligible for compensation.</li>
        </ul>
      </div>
    </div>
  </div>
</div>
